(ns ui.editor2.sidebar
  (:require [datascript.core :as ds]
            [ui.editor2.sticker]
            [ui.editor2.text :as text]
            [ui.editor2.thumbnail-generator]
            [ui.editor2.audio-player]
            [ui.editor2.sidebar-panel-ai :as sidebar-panel-ai]
            [ui.openrouter.sidebar-panel :as openrouter-panel]
            [ui.editor2.sidebar-panel-sticker :as sidebar-panel-sticker]
            [ui.editor2.sidebar-media :as media-sidebar]
            [ui.editor2.sidebar-hashtag :as hashtag-sidebar]
            [ui.editor2.sidebar-mention :as mention-sidebar]
            [ui.editor2.sidebar-link :as link-sidebar]
            [ui.editor2.sidebar-images :as images-sidebar]
            [ui.editor2.sidebar-giphy :as giphy-sidebar]
            [ui.editor2.sidebar-hyperframes-templates :as sidebar-hyperframes]
            [ui.editor2.sidebar-captions :as sidebar-captions]
            [ui.editor2.sidebar-emojies :as emoji-sidebar]
            [ui.editor2.sidebar-background :as sidebar-background]
            [ui.editor2.sidebar-slide :as sidebar-slide]
            [ui.editor2.sidebar-location :as sidebar-location]
            [ui.editor2.sidebar-music :as sidebar-music]
            [ui.editor2.sidebar-text-presets :as sidebar-text-preset]
            [ui.editor2.sidebar-canva :as sidebar-canva]
            [ui.editor2.common :as common]
            ))

(def x-icon
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :fill "none",
    :viewBox "0 0 24 24",
    :stroke-width "1.5",
    :stroke "currentColor",
    :class ["size-6" "text-slate-400"]}
   [:path
    {:stroke-linecap "round",
     :stroke-linejoin "round",
     :d "M6 18 18 6M6 6l12 12"}]])

(def upload-icon
  [:svg
   {:xmlns "http://www.w3.org/2000/svg",
    :fill "none",
    :viewBox "0 0 24 24",
    :stroke-width "1.5",
    :stroke "currentColor",
    :class ["size-6" "text-slate-400"]}
   [:path
    {:stroke-linecap "round",
     :stroke-linejoin "round",
     :d
     "M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5m-13.5-9L12 3m0 0 4.5 4.5M12 3v13.5"}]])

(defn clip-params-sidebar
  [state]
  (let [selected-clip (get-in state
                              [:editor2
                               :selected-clip])
        db (get-in state
                   [:editor2
                    :db])
        clip (ds/entity db [:clip/uuid selected-clip])]
    [:div
     {:class ["flex" "flex-col" "gap-2" "w-full" "mb-5"]}

     [:div
      {:class ["flex" "items-center" "justify-between" "w-full"]}
      [:span
       {:class ["text-xs" "font-medium"]}
       "Clip Parameter"]]
     [:ul.grid.grid-cols-2.gap-6.lg:grid-cols-2
      [:li.col-span-1.rounded-lg.shadow.divide-y
       [:span
        {:class ["text-xs" "font-medium"]}
        "Clip Start [ms]"]
       [:input.mr-2.max-w-full.w-full.bg-white.border-gray-900.rounded.text-gray-800.shadow-sm.focus:hover:border-gray-500.focus:shadow-md
        {:style {:background-color "oklch(0.21 0.034 264.665)"
                 :color "white"}
         :type "number"
         :name "Clip Start"
         :placeholder "start"
         :step "1"
         :min 0
         :max (:clip/end clip)
         :value (:clip/start clip)
         :on {:input [[:editor2/adapt-clip-data
                       {:clip/start :event/target.value-int}]]}}]]

      [:li.col-span-1.rounded-lg.shadow.divide-y
       [:span
        {:class ["text-xs" "font-medium"]}
        "Clip End [ms]"]
       [:input.mr-2.max-w-full.w-full.bg-white.border-gray-900.rounded.text-gray-800.shadow-sm.focus:hover:border-gray-500.focus:shadow-md
        {:style {:background-color "oklch(0.21 0.034 264.665)"
                 :color "white"}
         :type "number"
         :name "Clip End"
         :min (:clip/start clip)
         :placeholder "end"
         :value (:clip/end clip)
         :on {:input [[:editor2/adapt-clip-data
                       {:clip/end :event/target.value-int}]]}}]]]]))

(defn edit-sidebar [state modal-id]
  (let [db (get-in state
                   [:editor2
                    :db])
        clip-uuid (get-in state
                          [:editor2
                           :selected-clip])
        selected-clip (ds/pull db
                               '[*]
                               [:clip/uuid clip-uuid])
        selected-asset (when-let [selected (get-in selected-clip
                                                   [:clip/asset :db/id])]
                         (ds/pull db
                                  '[*]
                                  selected))]
    [:div
     {:class ["flex" "flex-col" "gap-2" "w-full"]}
     [:button.w-full.flex.items-center.justify-center.bg-gray-500.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     modal-id
                     (select-keys selected-asset [:asset/data
                                                  :asset/uuid
                                                  :db/id])]]}}
      [:span.hidden.lg:block.ml-2
       "Edit"]]]))

(defn params-side-bar
  [state panel]
  [:div
   (clip-params-sidebar state)
   (panel state)])

(defn edit-side-bar
  [state modal-id]
  [:div
   (clip-params-sidebar state)
   (edit-sidebar state modal-id)])

(defn sidebar
  [state]
  (case (get-in state [:editor2
                       :sidebar-panel])
    :media
    (media-sidebar/panel state)
    :ai
    (sidebar-panel-ai/panel state)
    ;; Nothing in the UI sets :openrouter — the panel is opened from the
    ;; DevTools console, see `ui.openrouter.devtools`:
    :openrouter
    (openrouter-panel/panel state)
    :sticker
    (sidebar-panel-sticker/panel state)
    :images
    (images-sidebar/panel state)
    :gif-sidebar
    (giphy-sidebar/panel state)
    :hyperframes-templates
    (sidebar-hyperframes/panel state)
    :hyperframes
    (sidebar-hyperframes/variables-panel state)
    :captions-sidebar
    (sidebar-captions/panel state)
    :emojies
    (emoji-sidebar/panel state)

    :hashtag-sticker
    (params-side-bar state hashtag-sidebar/hashtag-edit-sidebar)
    :mention-sticker
    (params-side-bar state mention-sidebar/mention-edit-sidebar)
    :link-sticker
    (params-side-bar state link-sidebar/link-edit-sidebar)
    :location-sticker
    (params-side-bar state sidebar-location/location-edit-sidebar)
    :music-sticker
    (params-side-bar state sidebar-music/music-edit-sidebar)
    :poll-sticker
    (edit-side-bar state :modals/editor2-poll-modal)
    :question-sticker
    (edit-side-bar state :modals/editor2-question-modal)
    :countdown-sticker
    (edit-side-bar state :modals/editor2-countdown-modal)
    :quiz-sticker
    (edit-side-bar state :modals/editor2-quiz-modal)
    :emoji-slider-sticker
    (edit-side-bar state :modals/editor2-emoji-slider-modal)
    :text-sticker
    [:div
     (clip-params-sidebar state)
     [:p.py-4 "This is a text element from the old editor."]
     [:ul.list-disc.ml-4
      [:li "Its content is " [:b "not editable"]]
      [:li [:b "#hashtags"] " and " [:b "@mentions"] " will not work"]
      ]]

    :background
    (sidebar-background/panel state)
    :canva
    (sidebar-canva/panel state)
    :slide
    (sidebar-slide/panel state)
    :text
    [:div
     (clip-params-sidebar state)
     (text/edit-panel state)]
    :text-presets
    (sidebar-text-preset/presets-panel state)

    ;; else
    (clip-params-sidebar state)

    ))

(defn panel
  [state]
  [:div
   ;; The stable scrollbar gutter keeps the panel's width while its
   ;; content grows past the height (e.g. while photos load):
   {:class ["box-border" "inline-flex" "p-6" "flex-col" "items-start" "gap-4" "overflow-x-hidden" "overflow-y-auto" "[scrollbar-gutter:stable]" "border" "bg-gray-800" "border-gray-800" "w-full" "h-full"]}
   ;; panel header
   [:div
    {:class ["flex" "items-center" "flex-row-reverse" "justify-between" "w-full"]}
    [:button
     {:class ["hover:bg-gray-900" "p-1" "rounded-md" "self-end"]
      :on {:click [[:store/assoc-in [:editor2 :sidebar-panel] nil]]}}
     x-icon]
    (when (= (get-in state
                     [:editor2
                      :sidebar-panel])
             :media)
      (common/tool-tip
        {:element [:div [:input.hidden
                         {:id common/media-upload-input-id
                          :type "file"
                          :multiple true
                          :accept "image/*,video/*,audio/*"
                          :on {:change [[:editor2/add-upload :event/target.files]
                                        [:editor2/reset-upload-input]]}}]
                   [:button
                    {:class ["hover:bg-gray-900" "p-1" "rounded-md"]
                     :on {:click [[:dom/click (str "#" common/media-upload-input-id)]]}}
                    upload-icon]]
         :text "Upload"
         :position :bottom}))]
   (sidebar state)])
